import React from "react"

export default class ShortAnswer extends React.Component {
	
	constructor(props) {
		super(props);

		this.onRespond = this.onRespond.bind(this);
	}

	render() {
		return (
			<div className="ShortAnswer">
				<input type="text" name={this.props.name} value={this.props.value} placeholder={this.props.placeholder} onChange={this.onRespond} />
			</div>
		);
	}

	onRespond() {
		if (typeof this.props.onRespond === 'function') {
			this.props.onRespond({
				questionId: this.props.question.id,
				text: "",
			});
		}
	}

}